/**
 * Languages loaded into the shared shiki highlighter. Highlighting a language missing from here throws, so code
 * that picks a language at runtime should check this list first and fall back to plain text.
 */
export const HIGHLIGHT_LANGUAGES = [
  'tsx',
  'scss',
  'html',
  'bash',
  'json',
  'csharp',
  // Common targets for the generated API request snippets
  'javascript',
  'python',
  'go',
  'java',
  'php',
  'ruby',
  'rust',
  'kotlin',
  'swift',
  'powershell',
  'http',
];

/** Language name shiki treats as plain text, without needing a grammar loaded */
export const PLAIN_TEXT_LANGUAGE = 'text';
